import { lazy } from "react";


import BookingDetails from "pages/BookingDetails";
import SearchForm from "pages/SearchForm";
import PaymentForm from "pages/PaymentForm";
import PrivacyPolicy from "pages/PrivacyPolicy";
import TermsAndConditions from "pages/TermsAndConditions";



const Bookings = lazy(() => import("pages/Bookings"));
const Services = lazy(() => import("pages/Services"));
const ServiceDetail = lazy(() => import("pages/Services/ServiceDetail"));
const NotAuthorize = lazy(() => import("pages/NotAuthorize"));
const Help = lazy(() => import("pages/Help"));
const Settings = lazy(() => import("pages/Settings"));

export { default } from "./AppRoutes";

export interface IRoute {
  path: string;
  element: JSX.Element;
}

export const public_routes: IRoute[] = [
  { path: "/", element: <Services /> },
  { path: "/service/:id", element: <ServiceDetail /> },
  { path: "/not-authorize", element: <NotAuthorize /> },
  { path: "/help", element: <Help /> },
  { path: "/settings", element: <Settings /> },
  { path: "/privacy", element: <PrivacyPolicy /> },
  { path: "/terms-and-conditions", element: <TermsAndConditions /> },
];

export const private_routes: IRoute[] = [
  { path: "/search-form", element: <SearchForm /> },
  { path: "/payment-form", element: <PaymentForm /> },
  { path: "/bookings", element: <Bookings /> },
  { path: "/booking/:id", element: <BookingDetails /> },
];
